export default "__VITE_ASSET__CCJY7YI0__"